// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__avocados_204211', '__avocados_Fallback_204211', Arial, sans-serif"},"className":"__className_204211","variable":"__variable_204211"};